










import { Component, Vue } from "vue-property-decorator";

import ProductForm from "./ProductForm/ProductForm.vue";
import { parseDirectoryProductId } from "./utils/openDirectoryProduct";

@Component({
  components: {
    ProductForm
  }
})
export default class ProductDirectoryEntityPage extends Vue {
  get entityId() {
    return parseDirectoryProductId(this.$route.params.id);
  }

  close() {
    // query (фильтр списка) сохраняется при возврате
    this.$router.push({
      name: "product-directory",
      query: this.$route.query
    });
  }
}
